import { gql } from "@apollo/client";

export interface LCSystem {
    feed_day_start: number
    fk_system_types: number
    pw_sources: number
    programmed: number
    min_feed_speed: number
    max_feed_speed: number
    default_amount: number
}


export const LC_SYSTEM = gql`
query GetLcSystem($domain: String!, $lanControllerId: Int!) {
	controller {
		lcSystem(domain: $domain, lanControllerId: $lanControllerId) {
			feed_day_start
			fk_system_types
			pw_sources
			programmed
			min_feed_speed
			max_feed_speed
			default_amount
		}
	}
}
`

export interface LCSystemResponse {
	controller: {
		lcSystem: LCSystem[] | null
	}
}

export interface LCSystemArgs {
	domain: string;
	lanControllerId: number;
}

